import { render, staticRenderFns } from "./ModalOnceAsk.vue?vue&type=template&id=71a47fa7&scoped=true&"
import script from "./ModalOnceAsk.vue?vue&type=script&lang=js&"
export * from "./ModalOnceAsk.vue?vue&type=script&lang=js&"
import style0 from "./ModalOnceAsk.vue?vue&type=style&index=0&id=71a47fa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a47fa7",
  null
  
)

export default component.exports